import {store} from "../App";

export function setWayfinderProfiles(profiles) {
    store.dispatch({type: "SET_WAYFINDER_PROFILES", profiles});
}

export function clearWayfinderProfiles() {
    store.dispatch({type: "CLEAR_WAYFINDER_PROFILES"});
}